module.exports = "//public.zight.com/packs/media/images/icons-settings-gray-a299f11cd72e6e530f88404fef0ae165.svg";